var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-center"},[_c('div',{staticClass:"content-wrap"},[_c('user-tab'),_c('div',{staticClass:"right-content"},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }